import { useEffect } from "react";

const k = (vId: string, cId: string) => (cId.includes(':') ? cId : `${vId}:${cId}`);

/** Keeps the service worker informed: the auth token it needs for API calls, and which channel to warm caches for. */
export function useServiceWorkerBridge({
  token,
  currentVoidId,
  currentChannelId,
}: {
  token: string;
  currentVoidId: string;
  currentChannelId: string;
}) {
  // Keep the service worker's auth token in sync so it can make authenticated API calls (e.g. decline call)
  useEffect(() => {
    if (!token || !('serviceWorker' in navigator)) return;
    navigator.serviceWorker.ready.then(reg => {
      reg.active?.postMessage({ type: 'SET_AUTH_TOKEN', data: token });
    }).catch(() => {});
  }, [token]);

  // Ask the service worker to warm up backlog caches for faster next cold start
  useEffect(() => {
    const cid = k(currentVoidId || 'home', currentChannelId);
    if (!token || !cid) return;
    if (!('serviceWorker' in navigator)) return;
    (async () => {
      try {
        const reg = await navigator.serviceWorker.ready;
        reg.active?.postMessage({ type: 'WARMUP', token, channelId: cid, spaceId: currentVoidId || 'home' });
      } catch { /* noop */ }
    })();
  }, [token, currentVoidId, currentChannelId]);
}
